import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let configPromise = null;

export const getPublicConfig = () => {
  if (!configPromise) {
    configPromise = api.config().then((c) => ({
      whatsapp: c.whatsapp_number || "",
      viber: c.viber_number || "",
      phone: c.company_phone || "",
      codFee: Number(c.cod_fee || 0),
      launchDate: c.launch_date || "",
      stripeMode: c.stripe_mode || "test",
    })).catch(() => ({ whatsapp: "", viber: "", phone: "", codFee: 0, launchDate: "", stripeMode: "test" }));
  }
  return configPromise;
};

export const usePublicConfig = () => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    getPublicConfig().then(setCfg);
  }, []);
  return cfg;
};

export const waLink = (number, text) =>
  `https://wa.me/${(number || "").replace(/^\+/, "")}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const viberLink = (number) => `viber://chat?number=${encodeURIComponent(number || "")}`;

export const telLink = (number) => `tel:${(number || "").replace(/[\s\-()]/g, "")}`;

export const formatPhone = (number) =>
  (number || "").replace(/^(\+30)(\d{3})(\d{3})(\d{4})$/, "$1 $2 $3 $4") || number;
